// ============================================================================
// LOGO COMPONENT - Reusable Lab2040 Logo
// ============================================================================

import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Logo Component - Shows logo IMAGE only
 * @param {'small' | 'default' | 'large'} size - Logo size
 * @param {boolean} linkToHome - Wrap in Link to home
 * @param {'light' | 'dark'} variant - Which background it's on
 * @param {string} className - Additional CSS classes
 */
const Logo = ({ 
  size = 'default', 
  linkToHome = true, 
  variant = 'light',
  className = '' 
}) => {
  // Size configurations
  const sizes = {
    small: 'h-10',
    default: 'h-12',
    large: 'h-14'
  };

  const sizeClass = sizes[size] || sizes.default;
  
  // variant='light' = on light background = use dark logo
  // variant='dark' = on dark background = use light logo
  const logoSrc = variant === 'light' ? '/logo-dark.png' : '/logo-light.png';

  const LogoImage = () => (
    <img 
      src={logoSrc}
      alt="Lab2040" 
      className={`${sizeClass} w-auto object-contain ${className}`}
    />
  );

  if (linkToHome) {
    return (
      <Link to="/" className="inline-flex">
        <LogoImage />
      </Link>
    );
  }

  return <LogoImage />;
};

/**
 * LogoText - Text-only version for minimal footers
 */
export const LogoText = ({ 
  size = 'default', 
  variant = 'light',
  linkToHome = true,
  className = '' 
}) => {
  const sizes = {
    small: 'text-lg',
    default: 'text-2xl',
    large: 'text-3xl'
  };

  // Text colors based on background
  const colors = {
    light: { lab: 'text-gray-900', year: 'text-teal-600' },
    dark: { lab: 'text-white', year: 'text-teal-400' }
  };

  const c = colors[variant] || colors.light;
  
  const Text = () => (
    <span className={`font-serif ${sizes[size] || sizes.default} font-bold ${className}`}>
      <span className={c.lab}>Lab</span>
      <span className={c.year}>2040</span>
    </span>
  );

  if (linkToHome) {
    return <Link to="/"><Text /></Link>;
  }
  
  return <Text />;
};

export default Logo;
